// extracted by mini-css-extract-plugin
module.exports = {"clickableIcon":"styles-module__clickableIcon___yeTiz"};